var map = {
	"./arrow-left.svg": 595,
	"./arrow-right.svg": 596,
	"./bowl.svg": 597,
	"./chevron-left.svg": 598,
	"./chevron_up.svg": 599,
	"./close.svg": 600,
	"./facebook.svg": 601,
	"./globe.svg": 602,
	"./instagram.svg": 603,
	"./linkedin.svg": 604,
	"./mail.svg": 605,
	"./map-location-marker.svg": 391,
	"./map-marker.svg": 388,
	"./menu.svg": 606,
	"./minus.svg": 607,
	"./muted.svg": 608,
	"./nuxt-logo.svg": 609,
	"./plus.svg": 610,
	"./rating-icon.svg": 611,
	"./twitter.svg": 612,
	"./unmuted.svg": 613,
	"./warning.svg": 614,
	"./world.svg": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 594;